export const ACTIONS = {
  PLAY_CHAT_SOUND: 'PLAY_CHAT_SOUND',
};

export const playChatSound = data => dispatch => {
  dispatch({
    type: ACTIONS.PLAY_CHAT_SOUND,
    payload: data,
  });
};
